import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "notice-table" }
const _hoisted_2 = ["onClick"]

import { ref,reactive } from 'vue'
import { useRouter } from 'vue-router'
import { getInstationMsgWarnApi } from '@/apis/notice'

export default /*@__PURE__*/_defineComponent({
  __name: 'NoticeDialog',
  setup(__props, { expose: __expose }) {

const router = useRouter()
const NoticeDialogList = ref([])
// 表单数据
const dialogShow = ref<boolean>(false) // 弹框状态
// 打开弹框
const openDialog = () => {
    dialogShow.value = true
    getInstationMsgWarn()
}
const closeDialog = () => {
    dialogShow.value = false
    const allType = NoticeDialogList.value.every(item => item.type === 2)
    if (allType) {
        router.push({path: '/notice/training-list',query: {file_type:1}}) 
    } else {
        router.push('/notice/notice-list') 
    }
}
const getInstationMsgWarn = async () => {
            const {code, data} = await getInstationMsgWarnApi() as any
            if (code == 200) {
               NoticeDialogList.value = data;  
            }
 }
const clickRowNotice = (item:any) => {
    dialogShow.value = false
    if (item.type === 2) {
         router.push({path: '/notice/training-list',query: {file_type: item.course_type === 1 ? 1 : 2}}) 
    } else {
       router.push({path: '/notice/notice-list',query: {title: item.title, desc: item.desc,rule_id:item.rule_id,notice:true}})
    }  
}   
// 暴露方法
__expose({
    openDialog
})

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "通知",
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dialogShow).value = $event)),
    width: "300px",
    style: {position: 'fixed', margin: '0',top: '70px',right: '20px'}
  }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(NoticeDialogList.value, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            class: "table-row",
            onClick: ($event: any) => (clickRowNotice(item))
          }, [
            _createTextVNode(_toDisplayString(item.title?.lenght > 11  ? item.title.slice(0, 11) + '...': item.title) + _toDisplayString(item.type === 2 ? item.course_type == 1 ?' - 视频' :' - 文档':'') + " ", 1),
            _cache[2] || (_cache[2] = _createElementVNode("span", { style: {"float":"right"} }, ">>", -1))
          ], 8, _hoisted_2))
        }), 128))
      ]),
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (closeDialog())),
        class: "close-btn"
      }, "查看更多")
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})